export default {
  content: {},
  textSpan:{},
  defaultStyle: {
    fontFamily: data => data.fontFamily1,
    padding: '10px',
    background: '#fff',
    position: 'sticky',
    left: '0',
    right: '0',
    bottom: '0',
    marginTop:'auto',
    boxShadow: '2px 0 4px 0 rgba(0,0,0,0.2)',
    webkitBoxShadow: '2px 0 4px 0 rgba(0,0,0,0.2)',
    MozBoxShadow: '2px 0 4px 0 rgba(0,0,0,0.2)',
    zIndex: '10',
    '& $content': {
      '& > div': {
        '& > button': {
          textAlign: 'center',
          width: '100%',
          height:'auto',
          minHeight:'40px',
          maxHeight:'50px',
          padding:'5px',
          '& $textSpan':{
            font:"16px 'Roboto', sans-serif",
          },
          '@media (min-width:801px)': {
            width:'auto',
            minWidth:'177px'
          },
          '&:lang(ar)': {
            '& > span': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              direction: 'rtl',
            }
          }
        },
        '&:lang(ar)': {
          '@media (min-width:801px)': {
            textAlign: "left",
            paddingLeft: "0",
            paddingRight: "25px"
          }
        }
      },
      '@media (min-width:801px)': {
        maxWidth: '1180px',
        margin: '0 auto',
        display: 'table',
        width: '100%',
        '& > div': {
          position: 'relative',
          display: 'table-cell',
          verticalAlign: 'middle',
          textAlign: 'right',
          width: '210px',
          paddingLeft: '25px',
          '& > button': {
            height: '50px',
            maxWidth: '250px',
            width:'auto',
            '& > span': {
              '&:lang(ar)': {
                display: 'block',
                direction: 'rtl'
              }
            }
          }
        }
      },
      '@media (min-width:901px)': {
        maxWidth: '1190px',
        display: 'block',
        '& > div': {
          display: 'block',
          width: 'auto',
          padding: '0 10px'
        }
      }
    },
    '@media (min-width:801px)': {
      padding: '20px'
    },
    '@media (min-width:901px)': {
      padding: '20px 10px'
    }
  },
  robotoBtn:{
    fontFamily:  'Roboto',
  },
};
